export const APP_DOMAIN = window.location.href.split('?')[0].replace(/\/+$/, '');
export const DOMAIN = "https://ai-render.s3.eu-central-1.amazonaws.com/";
export const isDevelopment = window.location.href.includes('localhost');
